import { type Commands } from '../commands';
import { Phase } from './entity';
import { Phases } from './repositoty';
import { type PhaseData } from './dto';

export class PhasesCommands implements Commands<Phases, Phase, PhaseData> {
    addAll(repo: Phases, data: PhaseData[]): Phases {
        repo.clear();
        repo.addAll(data.map((d) => new Phase(d)));
        return repo;
    }

    add(repo: Phases, data: PhaseData): Phases {
        repo.add(new Phase(data));
        return repo;
    }

    update(repo: Phases, entity: Phase): Phase {
        repo.update(entity);
        return entity;
    }

    remove(repo: Phases, id: string): void {
        repo.remove(id);
    }

    fromJSON(entity: Phase[], changeCallback: () => void): Phases {
        const newPhases = new Phases(changeCallback);
        entity.forEach((phase) => {
            newPhases.add(
                new Phase({
                    ...phase,
                }),
            );
        });
        return newPhases;
    }
}
